import { faqs, siteInfo } from "@/mocks/comics";

export default function SeoJsonLd() {
  const webSite = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "漫潮·韩国动态漫画精选榜",
    url: siteInfo.domain,
    inLanguage: "zh-CN",
  };

  const organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteInfo.brand,
    url: siteInfo.domain,
    description: siteInfo.slogan,
    email: siteInfo.contactEmail,
  };

  const webPage = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "漫潮·韩国动态漫画推荐排行榜｜人气热门作品精选",
    url: siteInfo.domain,
    description:
      "韩国动态漫画推荐与排行，人气榜单实时更新。精选热门高口碑作品一网打尽，覆盖奇幻、悬疑、恋爱、热血、末世等多类题材。",
    inLanguage: "zh-CN",
    isPartOf: { "@id": `${siteInfo.domain}#website` },
  };

  const faqPage = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  const scripts = [webSite, organization, webPage, faqPage];

  return (
    <>
      {scripts.map((s, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(s) }}
        />
      ))}
    </>
  );
}